var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['c-bcx-user-badge', _setup.badge.toLowerCase()]},[_c('img',{attrs:{"src":_setup.badgeURL,"alt":"Badge"},on:{"click":function($event){return _setup.emit('badge-clicked')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }